import { AxiosError } from "axios";
import { useQuery } from "react-query";
import http from 'infra/http';
import { ImpostoResponse } from './../typings/index';

export function useDetalheImposto(id?: string) {
  return useQuery<ImpostoResponse, AxiosError>(
    `/v1/imposto/${id}`,
    async () => {
      const { data } = await http.get<ImpostoResponse>(`/v1/imposto/${id}`)

      return data;
    },
    {
      enabled: !!id,
    }
  );
}
